export enum LocalStorage {
    PAY_ORDER = 'pay_order',
    PAYMENT_IN = 'payment_in',
    token = 'token',
    refresh_token = 'refresh_token',
    expiry_time = 'expiry_time',
    user = 'user',
    status = 'status',
    type = 'type',
    start_date = 'start_date',
    end_date = 'end_date',
    LANG = 'lang',
    page = 'page',
    limit = 'limit',
    total = 'total',
    ticket_type_param = 'ticket_type_param',
    payment_data = 'payment_data',
    go_back_url = 'go_back_url',
    his_status = 'his_status',
}
